export default function changeTab(newTab) {

    const nav = '.personalizator__product-image-content-controls>ul>li',
          tab = '.personalizator__insert-tab';


    $(tab).removeClass('active');
    $(nav).removeClass('active');

    $(newTab).addClass('active');
    $(`[data-tab="${newTab}"]`).addClass('active');
}